// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

require('./api/mock')

// https://blog.csdn.net/Monsters___/article/details/126552454
// 引入reset.css    修改build/webpack.base.conf的第30行
import 'css/reset.css'
import 'css/border.css'
import 'css/quill/quill.bubble.css'
import 'css/quill/quill.core.css'
import 'css/quill/quill.snow.css'
// 引入 jquery
import jquery from 'jquery'

// 引入 swiper 样式
import "swiper/css/swiper.min.css"

// 导入配置好的国际化语言包
import i18n from './i18n' // Internationalization

// 引入 element-ui
import ElementUI from 'element-ui';
// 点击弹窗以外不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false
// 引入 element-ui 样式
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value) // 在注册Element时设置i18n的处理方法,可以实现当点击切换按钮后，elementUI可以自动调用.js语言文件实现多语言切换
});

Vue.config.productionTip = false

Vue.prototype.$ = jquery

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js